import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const BlackInverseButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({ children, ...other }, ref) => {
  let notsetbackcolorwhendisabled = other.notsetbackcolorwhendisabled === 'true' ? true : false;
  const baseClass = !notsetbackcolorwhendisabled ? 'ifms-black-inverse-button' : 'ifms-black-inverse-button b';
  return (
    <IfmsButton ref={ref} {...other} baseClass={baseClass}>
      {children}
    </IfmsButton>
  );
});

BlackInverseButton.defaultProps = {
  notsetbackcolorwhendisabled: 'false'
};

BlackInverseButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large']),
  notsetbackcolorwhendisabled: PropTypes.string,
};

export default React.memo(BlackInverseButton);

